import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import { isAuthenticated } from 'utils/auth'
import request from 'utils/request'

import { SET_NEW_PASSWORD_URL } from 'constants'
import { statusChanged } from 'components/RequestStatus/actions'

import Input from 'components/Input'
import Button from 'components/Button'
import RequestStatus from 'components/RequestStatus'

import './style.scss'


export class SetPassword extends BaseComponent {
  constructor() {
    super()
    this.state = {
      buttonProps: {},
      token: null,
      formData: {
        password: '',
        password_confirmation: ''
      },
      errors: {}
    }
    this._bind('_onSubmit', '_onChange', '_validateToken')
  }

  componentWillMount() {
    if ( isAuthenticated() )
      this.context.router.history.replace('/')
    else
      this._validateToken()
  }

  _validateToken() {
    const userId = this.props.match.params.user_id,
      resetToken = this.props.match.params.token

    request(SET_NEW_PASSWORD_URL(userId, resetToken))
    .then(({ token }) => {
      if ( !token.is_active ) {
        const error = new Error('Invalid token')
        error.response = {
          status: 'error',
          message: 'Token inválido'
        }
        throw error
      }
      this.setState({ userId, token: resetToken })
    })
    .catch((e) => {
      this.context.router.history.replace('/users/password-recovery/', {...e.response})
    })
  }

  componentDidMount() {
    document.title = 'Custodian | Iniciar Sesión'
  }

  // we need to use asyn-await here in order to test it :(
  // TODO: find a way that avoids using async-await
  async _onSubmit(e) {
    e.preventDefault()
    this.props.updateRequestStatus('progress', 'Actualizando contraseña...')
    this.setState({
      buttonProps: { disabled: true }
    })

    await request(SET_NEW_PASSWORD_URL(this.state.userId, this.state.token), {
      method: 'POST',
      body: { ...this.state.formData }
    })
    .then((response) => {
      this.context.router.history.replace('/users/login/', {...response})
    })
    .catch(({response}) => {
      const errors = !!response.fields ? {...response.fields} : {}
      this.props.updateRequestStatus(response.status, response.message)
      this.setState({
        buttonProps: {},
        errors: {...errors}
      })
    })
  }

  _onChange(evt) {
    this.setState({
      formData: {
        ...this.state.formData,
        [evt.target.name]: evt.target.value
      }
    })
  }

  render () {
    return (
      <div id="SetPassword">
        <div className="SetPassword__section_title row align-items-center">
          <h5 className="col-md-7">Nueva contraseña</h5>
          <div className="col-md-5">
            <Link to="/users/login" replace className="Button btn btn-inverse ">
              Iniciar sesión
            </Link>
          </div>
        </div>
        <form onSubmit={this._onSubmit} className="SetPassword__form">
          <div className="SetPassword__form__fields">
            <Input
              type="password"
              icon="lock"
              tabIndex="1"
              name="password"
              size="big"
              required
              autoFocus
              value={this.state.formData.password}
              onChange={this._onChange}
              errors={this.state.errors.password}
              placeholder="Nueva contraseña"
            />
            <Input
              type="password"
              name="password_confirmation"
              icon="lock"
              size="big"
              required
              tabIndex="2"
              value={this.state.formData.password_confirmation}
              onChange={this._onChange}
              errors={this.state.errors.password_confirmation}
              placeholder="Confirmar nueva contraseña"
            />
          </div>
          <div className="SetPassword__form__indicator">
            <RequestStatus />
          </div>
          <div className="SetPassword__form__actions row align-items-center">
            <div className="col">
              <Button
                type="submit"
                buttonType="primary"
                tabIndex="3"
                size="big"
                {...this.state.buttonProps}
              >
                CAMBIAR CONTRASEÑA
              </Button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(null, mapDispatchToProps)(SetPassword)

SetPassword.contextTypes = {
  router: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/scenes/SetPassword/index.js